import { Card, Col, Row, Modal, Tooltip, Button, Form, Input, message } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { useState } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useLocalStorage } from "usehooks-ts";
import { useTranslation } from "react-i18next";

const { Item } = Form;

const CompleteProfileModal = ({ open, setOpen }) => {
    const [user, setUser] = useLocalStorage("user", null);
    const { t } = useTranslation();

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    if (!open) return null;

    const onFinish = async (values) => {
        try {
            HTTPClient.put("/users/", values);
            message.success(t("profile.info_card.form.success"));
            setOpen(false);

            let response = await HTTPClient.get("/auth/user");
            const logged_user = {
                ...response.data.user_data,
                wallet: response.data.wallet,
                is_profile_complete: response.data.is_profile_complete,
            };
            setUser(logged_user);
        } catch (error) {
            message.error(t("profile.info_card.form.error"));
        }
    };

    return (
        <Modal
            open={open}
            title={
                !user.is_profile_complete
                    ? t("profile.info_card.call_to_action.edit")
                    : t("profile.info_card.call_to_action.update")
            }
            okText={""}
            cancelText={""}
            width={isLargeScreen ? "80vw" : "100vw"}
            footer={null}
            destroyOnClose
            onCancel={() => {
                setOpen(false);
            }}>
            <div style={{ width: "100%", maxHeight: "80vh", overflow: "auto" }} />
            <Form
                style={{ marginTop: "10px" }}
                name="updateInfoForm"
                onFinish={onFinish}
                layout="vertical"
                initialValues={{
                    phone: user?.phone,
                    address: {
                        county: "IT",
                        address: user?.address?.address,
                        city: user?.address?.city,
                        province: user?.address?.province,
                        postalCode: user?.address?.postalCode,
                    },
                }}>
                <Item
                    name={["phone"]}
                    label={t("profile.info_card.form.phone.label")}
                    rules={[
                        {
                            required: true,
                            message: t("profile.info_card.form.phone.error"),
                            pattern: new RegExp(/\d{10}/g),
                        },
                    ]}>
                    <Input
                        placeholder={t("profile.info_card.form.phone.label")}
                        style={{ height: "3rem" }}
                    />
                </Item>
                <Item
                    name={["address", "address"]}
                    label={t("profile.info_card.form.address.label")}
                    rules={[
                        { required: true, message: t("profile.info_card.form.address.error") },
                    ]}>
                    <Input
                        placeholder={t("profile.info_card.form.address.label")}
                        style={{ height: "3rem" }}
                        label={t("profile.info_card.form.address.label")}
                    />
                </Item>
                <Item
                    name={["address", "city"]}
                    label={t("profile.info_card.form.city.label")}
                    rules={[{ required: true, message: t("profile.info_card.form.city.error") }]}>
                    <Input
                        placeholder={t("profile.info_card.form.city.label")}
                        style={{ height: "3rem" }}
                        label={t("profile.info_card.form.city.label")}
                    />
                </Item>
                <Item
                    name={["address", "province"]}
                    label={t("profile.info_card.form.province.label")}
                    rules={[
                        { required: true, message: t("profile.info_card.form.province.error") },
                    ]}>
                    <Input
                        placeholder={t("profile.info_card.form.province.label")}
                        style={{ height: "3rem" }}
                        label={t("profile.info_card.form.province.label")}
                    />
                </Item>
                <Item
                    name={["address", "postalCode"]}
                    label={t("profile.info_card.form.postalCode.label")}
                    rules={[
                        { required: true, message: t("profile.info_card.form.postalCode.error") },
                    ]}>
                    <Input
                        placeholder={t("profile.info_card.form.postalCode.label")}
                        style={{ height: "3rem" }}
                        label={t("profile.info_card.form.postalCode.label")}
                    />
                </Item>
                <Row style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end" }}>
                    <Item>
                        <Button type="primary" htmlType="submit" size="large">
                            {!user.is_profile_complete
                                ? t("profile.info_card.form.call_to_action.edit")
                                : t("profile.info_card.form.call_to_action.update")}
                        </Button>
                    </Item>
                </Row>
            </Form>
        </Modal>
    );
};

const InfoCard = () => {
    const [user] = useLocalStorage("user", null);
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <>
            <Card
                title={t("profile.info_card.title")}
                style={{ width: isLargeScreen ? "50vw" : "75vw" }}
            >
                <Row>
                    <Col xs={6} md={6}>
                        {t("profile.info_card.name")}
                    </Col>
                    <Col xs={18} md={18}>
                        {user?.name} {user?.surname}
                    </Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                    <Col xs={6} md={6}>
                        {t("profile.info_card.email")}
                    </Col>
                    <Col xs={18} md={18}>
                        {user?.email}
                    </Col>
                </Row>
            </Card>
            <CompleteProfileModal open={open} setOpen={setOpen} />
        </>
    );
};

export { InfoCard };
